export default function Config(key) {
    if(window.menopauseTestConfig.hasOwnProperty(key)){
        return window.menopauseTestConfig[key]
    }

    throw new Error('Missing config parameter: ' + key);
}